export default function externalLinks () {
  const anchors = document.querySelectorAll('a')
  anchors.forEach(anchor => {
    if (anchor.hostname !== window.location.hostname) {
      anchor.setAttribute('target', '_blank')
    }
  })
}



// WEBPACK FOOTER //
// ./themes/default/js/modules/externalLinks.js